const sendLeadDataToApi = async (
  id: string,
  data: Record<string, unknown>,
): Promise<unknown> => {
  if (!id) {
    throw new Error('A valid `id` must be provided.');
  }

  const hostname: string =
    window?.location?.hostname?.replace(/^www\./, '') || 'localhost';

  let apiUrl = 'https://leads.organogenesis.dev';
  if (hostname === 'localhost') {
    apiUrl = 'https://leads.organogenesis.dev';
  } else if (hostname.endsWith('.com')) {
    apiUrl = 'https://leads.organogenesis.com';
  } else if (hostname.endsWith('.dev')) {
    apiUrl = 'https://leads.organogenesis.dev';
  }

  try {
    const response = await fetch(`${apiUrl}/webform_rest/submit`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ webform_id: id, ...data }),
    });

    if (!response.ok) {
      throw new Error(await response.text());
    }

    return await response.json();
  } catch (error) {
    throw new Error(
      `Failed to send lead data: ${
        error instanceof Error ? error.message : String(error)
      }`,
    );
  }
};

export { sendLeadDataToApi };
